import { HIDE_LOCKOUT_MODAL } from 'actions'

const initialState = {
  step: 'initial_prompt',
  isVisible: true
}

export default function(state = initialState, { type, payload }) {
  switch (type) {
    case HIDE_LOCKOUT_MODAL:
      return {
        ...state,
        isVisible: false
      }
    default:
      return state
  }
}
